<template>
  <span class="chip">{{ name }}</span>
</template>

<script>
export default {
  name: 'TagChip',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.chip {
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 2px;
  padding: 0.2em 0.3em;
  background-color: #eee;
  color: #666;
  font-size: 14px;
}
</style>
